
import SEO from "@/components/SEO";

const websiteUrl = "https://nearlabservices.com";
const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(websiteUrl)}&color=0d4f52&bgcolor=ffffff&margin=20`;

const QRCodePage = () => {
  const handleDownload = async () => {
    const response = await fetch(qrUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "nearlab-qrcode.png";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <SEO
        title="NearLab Services | QR Code"
        description="Scan to visit NearLab Services – Mobile DNA & DOT Testing"
      />
      <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 py-16">
        <div className="bg-card border border-border rounded-2xl shadow-lg p-10 flex flex-col items-center gap-6 max-w-sm w-full">
          {/* Logo / Title */}
          <div className="text-center">
            <h1 className="text-2xl font-bold text-primary">NearLab Services</h1>
            <p className="text-muted-foreground text-sm mt-1">Scan to visit our website</p>
          </div>

          {/* QR Code */}
          <div className="border-4 border-primary rounded-xl overflow-hidden shadow-md">
            <img
              src={qrUrl}
              alt="NearLab Services QR Code"
              width={300}
              height={300}
              className="block"
            />
          </div>

          {/* URL */}
          <p className="text-xs text-muted-foreground text-center break-all">{websiteUrl}</p>

          {/* Download Button */}
          <button
            onClick={handleDownload}
            className="w-full bg-primary text-primary-foreground font-semibold py-3 rounded-lg hover:bg-primary/90 transition-colors"
          >
            Download QR Code
          </button>
        </div>
      </div>
    </>
  );
};

export default QRCodePage;
